import * as rdd from 'react-device-detect';

class AnalyticsService {
  private analyticData: any;

  constructor() {
    this.analyticData = {};
  }

  createAnalyticData(event?: string) {
    const { userAgent } = window.navigator;
    const page = window.location.pathname;
    const { origin } = window.location;
    const timestamp = new Date();
    this.analyticData = {
      event,
      timestamp,
      page,
      userAgent,
      origin,
      browser: `${rdd.browserName} version ${rdd.browserVersion}`,
      platform: rdd.deviceType,
    };
    return this.analyticData;
  }

  isMobileDevice() {
    return rdd.isMobile;
  }

  getAnalytics() {
    return this.analyticData;
  }
}

export default new AnalyticsService();
